import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const saveApplePayDeliveryInstruction: CheckoutActionCreator = (
  deliveryInstruction: string,
) => ({
  type: actionTypes.SAVE_APPLE_PAY_DELIVERY_INSTRUCTION,
  deliveryInstruction,
})
